const amountOfAiImagesOnPage = 15;

export default amountOfAiImagesOnPage;
